import { Component, Prop, Vue } from 'vue-property-decorator'
const mixin = {
  computed: {
  },
  data() {},
  methods: { }
}
export default (tmp: any) => {
  Object.assign(mixin, {
    data() {
      return {
        ...tmp
      }
    }
  })
  return mixin
}
